import * as React from 'react';
import Box from '@mui/material/Box';
import SidebarMenu from "./SidebarMenu";  // ✅ 정확한 파일명과 일치
import "../css/reset.css";
import "../css/layout.css";
import "../css/common.css";
import "../css/style.css";
import "../css/dashboard.css";
import "../css/lnb.css";
import { WeatherPaper } from 'pages/components/WeatherPaper';
import { SwItsTrafficLosProvider, LosChartLabel, SwItsTrafficLosChart,SwItsTrafficLosGrid ,SwItsTrafficLosTotalCnt } from 'pages/components/dashboard/SwItsGetCrsrdLos';
import { SwItsEmergVehTotalProvider, SwItsEmergVehTotalInfo, SwItsEmergVehTotalShorteningTime } from 'pages/components/dashboard/SwItsGetEmergVeh';
import { SwItsSnstvSignalProvider, SwItsSnstvSignalTotalInfo, SwItsIncreaseGreenSignalTotalInfo , SwItsSnstvSignalTotalCnt } from 'pages/components/dashboard/SwItsGetSnstvSignal';
import { LosTitleWithCount } from 'pages/components/dashboard/SwItsGetCrsrdLos';

import { useTranslation } from 'react-i18next';
export default function SignalOperationViewD() {

    React.useEffect(() => {

    }, []);
     const { t, i18n } = useTranslation();
    
      const toggleLanguage = () => {
        const newLang = i18n.language === 'ko' ? 'en' : 'ko';
        i18n.changeLanguage(newLang);
      };
    return (
        <Box sx={{ height: '100%', width: '100%' }}>
            <div className="dashboard container flx a_center">
                <SidebarMenu />
                <div className="ctrlMain">
                    <div className="mainTit flx j_spc_btw a_center">
                        <div className="titBox">
                            <p
                                className={`subTit${i18n.language === 'en' ? '_en' : ''}`}
                                onClick={toggleLanguage}
                                style={{ cursor: 'pointer', userSelect: 'none' }}
                            >
                                {t('subtitle')}
                            </p>
                            <p className={`tit${i18n.language === 'en' ? '_en' : ''}`}>
                                {t('mainTitle3')}
                            </p>
                        </div>
                        <div className="weatherWrap flx a_center j_spc_btw">
                            <WeatherPaper sx={{ width: '300px' }} />
                        </div>
                    </div>
                    <SwItsTrafficLosProvider>
                        <div className="mainInfo L_lr">{/*메인박스*/}
                            <div className='L_2m L_tb'>
                                <div className='L_d inner flx flx_col'>
                                    <div className='titWrap flx j_spc_btw'>
                                        {/* <h2 className="boxTit">교차로 LOS</h2> */}
                                        <SwItsTrafficLosTotalCnt/>
                                    </div>
                                    <div className='losConts flx flx_col j_center'>
                                        <div className='losConts flx flx_col j_center'>
                                            <div className='losGrid innerBg flx a_center'>
                                                <div className="titBox">
                                                    <LosTitleWithCount />
                                                    <p className="tit">최근 1시간</p>
                                                    <p className="tit">월 평균</p>
                                                </div>
                                                <div className='infoBox flx flx_col j_spc_btw'>
                                                    <div className='losDvd flx a_center j_spc_btw'>
                                                        <p className='flx a_center j_center'>
                                                            <img src='/images/dashboard/los_A.png' alt='losA'></img>
                                                            <span style={{ fontSize: 'var(--ft-42)', marginLeft: '2px', color: 'var(--iv-07)' }}>A</span>
                                                        </p>
                                                        <p className='flx a_center j_center'>
                                                            <img src='/images/dashboard/los_B.png' alt='losA'></img>
                                                            <span style={{ fontSize: 'var(--ft-42)', marginLeft: '2px', color: 'var(--iv-06)' }}>B</span>
                                                        </p>
                                                        <p className='flx a_center j_center'>
                                                            <img src='/images/dashboard/los_C.png' alt='losA'></img>
                                                            <span style={{ fontSize: 'var(--ft-42)', marginLeft: '2px', color: 'var(--iv-05)' }}>C</span>
                                                        </p>
                                                        <p className='flx a_center j_center'>
                                                            <img src='/images/dashboard/los_D.png' alt='losA'></img>
                                                            <span style={{ fontSize: 'var(--ft-42)', marginLeft: '2px', color: 'var(--iv-04)' }}>D</span>
                                                        </p>
                                                        <p className='flx a_center j_center'>
                                                            <img src='/images/dashboard/los_E.png' alt='losA'></img>
                                                            <span style={{ fontSize: 'var(--ft-42)', marginLeft: '2px', color: 'var(--iv-03)' }}>E</span>
                                                        </p>
                                                        <p className='flx a_center j_center'>
                                                            <img src='/images/dashboard/los_F.png' alt='losA'></img>
                                                            <span style={{ fontSize: 'var(--ft-42)', marginLeft: '2px', color: 'var(--iv-02)' }}>F</span>
                                                        </p>
                                                        <p className='flx a_center j_center'>
                                                            <img src='/images/dashboard/los_Nd.png' alt='losA'></img>
                                                            <span style={{ fontSize: 'var(--ft-42)', marginLeft: '2px', color: 'var(--white-50)' }}>-</span>
                                                        </p>
                                                    </div>
                                                    <SwItsTrafficLosGrid/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='losChart flx a_center j_spc_btw'>
                                             <LosChartLabel /> 
                                            <div className='losChartRight'>
                                                 <SwItsTrafficLosChart /> 
                                                </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='L_d inner flx flx_col'>
                                        <SwItsSnstvSignalProvider>
                                    <div className='titWrap flx j_spc_btw'>
                                        <SwItsSnstvSignalTotalCnt/>
                                    </div>
                                    <div className='snstvSgnlConts L_lr'>
                                            <div className='L_2m_20 innerBg flx flx_col j_center cst_wd6'>
                                                <SwItsSnstvSignalTotalInfo />
                                            </div>
                                            <div className='L_2m_20 innerBg flx flx_col j_center cst_wd4'>
                                                <SwItsIncreaseGreenSignalTotalInfo />
                                            </div>
                                    </div>
                                        </SwItsSnstvSignalProvider>
                                </div>
                            </div>
                            <div className='L_2m L_tb'>
                                <div className='L_d inner flx flx_col'>
                                    <div className='titWrap flx j_spc_btw'>
                                         <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--caution)'}}>{t('EmergencyVehicleOperation')}
                                        </h2>
                                    </div>
                                    <div className='emergVehConts L_tb'>
                                        <SwItsEmergVehTotalProvider>
                                            <div className='L_d_i innerBg flx flx_col j_center'>
                                                <SwItsEmergVehTotalInfo />
                                            </div>
                                            {/* <div className='L_2m_20 L_lr'>
                                            </div> */}
                                            <SwItsEmergVehTotalShorteningTime />
                                        </SwItsEmergVehTotalProvider>
                                    </div>
                                </div>
                                <div className='L_d L_lr'>
                                    <div className='L_2m_20 inner'>
                                        <div className='titWrap flx j_spc_btw'>
                                            <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{letterSpacing:'-4.5px', marginLeft:'-8px' , color:'var(--iv-08)'}}>{t('RealtimeSignalInformationSharing')}</h2>
                                        </div>
                                        <div className='sgnlConts innerBg flx flx_col a_center j_center gap20' style={{borderRadius:'40px'}}>
                                            <div className='flx a_flx_end j_center'>
                                                <span className='nbr'>90</span>
                                                <span className='subTxt'>개소</span>
                                                {/* <span className='subTxt' style={{ fontSize: 'var(--ft-56)', fontWeight: 'var(--ft-Bold)', margin: '0 20px 14px', color: 'var(--white-50)' }}>/</span>
                                                <span className='nbr' style={{ color:'var(--white-50)' }}>20</span>
                                                <span className='subTxt' style={{color:'var(--white-50)'}}>개소</span> */}
                                            </div>
                                            <div className='flx a_center j_center  gap20'>
                                                <div className='imgBox'>
                                                    <img src="/images/module/Tmap.png"></img>
                                                </div>
                                                <div className='imgBox'>
                                                   <img src="/images/module/Naver.png"></img>
                                                </div>
                                                <div className='imgBox'>
                                                    <img src="/images/module/KaKaoMap.png"></img>
                                                </div>
                                                <div className='imgBox'>
                                                    <img src="/images/module/KaKaoNav.png"></img>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='L_2m_20 inner' style={{padding: '40px'}}>
                                        <div className='titWrap flx j_spc_btw'>
                                             <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`}  style={{color:'var(--iv-07)', letterSpacing:'-3px'}}>{t('SignalControllerStatus')}</h2>
                                        </div>
                                        <div className='sgnlCtrlConts flx flx_col'>
                                            <div className='sgnlCtrlContsLi innerBg flx a_center j_spc_btw'>
                                                <p className='cmpr ft20' style={{letterSpacing:'-4px'}}>총 신호제어기</p>
                                                <div className='flx a_flx_end j_center'>
                                                    <span className='nbr' style={{ color:'var(--white-80)', fontSize:'var(--ft-42)' }}>1,342</span>
                                                    <span className='unit' style={{color:'var(--white-50)', fontSize:'var(--ft-24)', marginBottom:'0 0 3px 4px'}}>개소</span>
                                                </div>
                                            </div>
                                            <div className='sgnlCtrlContsLi innerBg flx a_center j_spc_btw'>
                                                <p className='cmpr ft20' style={{letterSpacing:'-4px'}}>실시간 신호제어기</p>
                                                <div className='flx a_flx_end j_center'>
                                                    <span className='nbr' style={{ color:'var(--white-80)', fontSize:'var(--ft-42)' }}>1,213</span>
                                                    <span className='unit' style={{color:'var(--white-50)', fontSize:'var(--ft-22)', marginBottom:'0 0 3px 4px'}}>개소</span>
                                                    {/* <span className='unit' style={{color:'var(--white-80)', fontSize:'var(--ft-22)'}}>(91.3%)</span> */}
                                                </div>
                                            </div>
                                            <div className='sgnlCtrlContsLi innerBg flx a_center j_spc_btw'>
                                                <p className='cmpr ft20' style={{letterSpacing:'-4px'}}>연동그룹(SA)</p>
                                                <div className='flx a_flx_end j_center'>
                                                    <span className='nbr' style={{ color:'var(--white-80)', fontSize:'var(--ft-42)' }}>333</span>
                                                    <span className='unit' style={{color:'var(--white-50)', fontSize:'var(--ft-24)', marginBottom:'0 0 3px 4px'}}>개</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='titWrap flx a_flx_end j_spc_btw'>
                                        <h2 className="boxTit">실시간 신호개방</h2>
                                    </div>
                                    <div className='sgnlConts L_lr'>
                                        <div className='L_2m_20 innerBg flx a_center j_center' style={{width:'100%', height:'calc(100% - 22px)', marginTop:'22px', borderRadius: '40px',}}>
                                            <div className='flx a_flx_end j_center'>
                                                <span className='nbr'>20</span>
                                                <span className='subTxt'>개소</span>
                                                <span className='subTxt' style={{ fontSize: 'var(--ft-56)', fontWeight: 'var(--ft-Bold)', margin: '0 20px 14px', color: 'var(--white-50)' }}>/</span>
                                                <span className='nbr' style={{ color:'var(--white-50)' }}>20</span>
                                                <span className='subTxt' style={{color:'var(--white-50)'}}>개소</span>
                                            </div>
                                        </div>
                                        <div className='L_2m_20 innerBg flx a_center j_center' style={{width:'100%', height:'calc(100% - 22px)', marginTop:'22px', borderRadius: '40px',}}>
                                            <p style={{fontSize : '30px'}}>들어갈 이미지 필요합니다</p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </SwItsTrafficLosProvider>
                </div>
            </div>
        </Box>
    )
}